import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/global.scss';
import 'react-loading-skeleton/dist/skeleton.css';
import 'react-notifications-component/dist/theme.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'animate.css';
import 'ol/ol.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CustomHistoryRouter } from './components/customHistoryRouter';
import NotificationProvider from './components/notificationProvider';
import history from './common/history';
import DialogWarningExpired from './components/inactivityProvider';
import LockScreen from './components/lockScreen';
import './i18n';
import { UserProvider } from './hooks/useUserInfo';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <>
    <NotificationProvider />
    <DialogWarningExpired />
    <CustomHistoryRouter history={history}>
      <LockScreen />
      <UserProvider>
        <App />
      </UserProvider>
    </CustomHistoryRouter>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
